

module.exports = require('./dist/zoomus-websdk-embedded.umd.min');



//////////////////
// WEBPACK FOOTER
// /Users/norbert/Documents/GitHub/endurance-trade/web/app/themes/wraith/node_modules/@zoomus/websdk/embedded.js
// module id = 28
// module chunks = 0